import React from 'react';

const QuestionSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.33594 8.30467C8.33594 3.97546 15.6631 3.9647 15.6631 8.30455C15.6631 11.5541 11.7134 10.2931 11.7134 14.8599" stroke="white" stroke-opacity="0.6" stroke-width="1.3"/>
    <rect x="11.6" y="17.4463" width="0.3" height="0.3" fill="white" fill-opacity="0"/>
  </svg>
);

export default QuestionSvg;